import { getAntiForgeryToken } from '../lib/helpers';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('import-session-container');
    if (!container) return;

    const urlRowTemplate = container.dataset.urlRow ?? '';

    document.querySelectorAll<HTMLInputElement>('.row-include-check').forEach(checkbox => {
        checkbox.addEventListener('change', async () => {
            const rowId = checkbox.dataset.rowId;
            if (!rowId) return;

            checkbox.disabled = true;
            try {
                const url = urlRowTemplate.replace('__rowId__', rowId);
                const resp = await fetch(url, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'RequestVerificationToken': getAntiForgeryToken()
                    },
                    body: JSON.stringify({ isApproved: checkbox.checked })
                });
                const json = await resp.json();
                if (!json.success) {
                    checkbox.checked = !checkbox.checked;
                    alert(json.message ?? 'Error updating row');
                }
            } catch {
                checkbox.checked = !checkbox.checked;
            } finally {
                checkbox.disabled = false;
            }
        });
    });
});
